<ng-template #content role="document" let-modal>

  <div class="modal-header bg-primary">
    <div class="col">
      <h5 *ngIf="!property || !property?.title" class="modal-title text-white" id="userModalLabel">
        {{textAddOrUpdateModalTitle | translate}}
      </h5>
      <h5 *ngIf="property && property?.title" class="modal-title text-white" id="userModalLabel">
        {{textAddOrUpdateModalTitle | translate}} - {{property.title}}
      </h5>
    </div>

    <div class="col-lg-8 m-n2 rounded"
      [ngClass]="{'d-none':warningSubject$.getValue()===0 || (loginUser.id!==property?.mainAgent && property && !permissionsService.canEditProperty(loginUser, property?.store?.id))}">
      <div class="dropdown pe-3 float-end" ngbDropdown>
        <button type="button" class="btn btn-icon rounded-circle border border-dashed border-white bg-primary"
          ngbDropdownToggle>
          <i class="bx bx-error fs-22 ms-1 text-white"></i>
          <span
            class="position-absolute fs-10 translate-middle badge rounded-pill bg-danger ms-5 ">{{warningSubject$.getValue()}}<span
              class="visually-hidden">{{'t-info' | translate}}</span>
          </span>
        </button>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
          <div class="dropdown-head bg-soft-danger rounded-top">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold text-danger"> {{'t-info' | translate}} </h6>
                </div>
                <div class="col-auto dropdown-tabs">
                  <span class="badge bg-danger fs-13 text-white rounded-circle">
                    {{warningSubject$.getValue()}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <ngx-simplebar class="px-3 mx-n3 mb-2" [ngStyle]="{ 'height.vh': 67 }" [options]="{ forceVisible: true }">
              <h6 class="fs-15" *ngIf="!canActivateProperties.available">{{'t-validation.t-general' |
                translate}}</h6>
              <ng-container *ngIf="!canActivateProperties.available">
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p [innerHTML]="authService.currentUserValue.role?.name==='MASTER' ? ('t-validation.t-properties-limit' | translate) : ('t-validation.t-properties-limit-agent' | translate)"
                      class="text-muted mb-0">
                    </p>
                  </div>
                </div>
              </ng-container>

              <h6 class="fs-15" *ngIf="detailsForm?.errors?.length>0">{{'t-details' | translate}}</h6>
              <ng-container *ngFor="let error of detailsForm?.errors; index as i">
                <div class="d-flex mt-2 mb-4" *ngIf="error.type?.warning && error.key==='reference'">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill" [ngClass]="{' text-danger':error.type?.warning}"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-m-properties.t-info-key-form.t-'+error.key | translate}} {{'t-exist' |
                      translate}}
                    </p>
                  </div>
                </div>
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{' text-warning':error.type?.warning, ' text-danger':error.type?.required}"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-m-properties.t-info-key-form.t-'+error.key | translate}}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                    <p class="text-muted mb-0" *ngIf="error.type?.required">
                      {{'t-m-properties.t-info-key-form.t-'+error.key | translate}}
                      {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' |
                      translate}}
                    </p>
                  </div>
                </div>
              </ng-container>
              <h6 class="fs-15" *ngIf="addressForm?.errors?.length>0">
                {{'t-m-properties.t-address' | translate}}
              </h6>
              <ng-container *ngFor="let error of addressForm?.errors; index as i">
                <div class="d-flex mt-2 mb-4">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{' text-warning':error.type?.warning, ' text-danger':error.type?.required}"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="error.type?.warning">
                      {{'t-'+error.key | translate }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                    <p class="text-muted mb-0" *ngIf="error.type?.required">
                      {{'t-'+error.key | translate }}
                      {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' |
                      translate}}
                    </p>
                  </div>
                </div>
              </ng-container>
              <h6 class="fs-15"
                *ngIf="propertyAdvertisementData?.errors?.length===dataToFormInitAdvertisement?.langs?.length">
                {{'t-m-properties.t-advertisement' | translate }}
              </h6>
              <ng-container
                *ngIf="propertyAdvertisementData?.errors?.length===dataToFormInitAdvertisement?.langs?.length">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill"
                      [ngClass]="{' text-warning':propertyAdvertisementData?.errors[0].type?.warning || propertyAdvertisementData?.errors[0].type?.required}"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0" *ngIf="propertyAdvertisementData?.errors[0].type?.warning">
                      {{'t-title' | translate }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>

                  </div>
                </div>
              </ng-container>
              <h6 class="fs-15" *ngIf="propertyMultimediaData?.errors?.length===1">
                {{'t-m-properties.t-multimedia' | translate }}
              </h6>
              <ng-container *ngIf="propertyMultimediaData?.errors?.length===1">
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-m-properties.t-images' | translate }}
                      {{'t-or' | translate }}
                      {{'t-m-properties.t-videos' | translate | lowercase }}
                      {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
                    </p>
                  </div>
                </div>
                <div class="d-flex mt-2 mb-3">
                  <div class="flex-shrink-0">
                    <i class="ri-checkbox-circle-fill text-warning"></i>
                  </div>
                  <div class="flex-grow-1 ms-2">
                    <p class="text-muted mb-0">
                      {{'t-m-properties.t-images_or_videos_must_also_be_activated' | translate }}
                    </p>
                  </div>
                </div>
              </ng-container>
            </ngx-simplebar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto mt-2">
      <button type="button" class="btn-close btn-close-white" aria-label="Close" id="close-modal"
        (click)="modal.dismiss('Cross click')">
      </button>
    </div>
  </div>

  <!-- <div *ngIf="!property && !typeSelected" class="modal-body pt-0">
        <h4 class="my-5 text-center">Escolha o tipo do Empreendimento que será criado</h4>
        <div class="development-choices">
            <div (click)="typeSelected = 1" class="align-items-center border card cursor-pointer d-flex flex-column h-100 p-4 rounded-3 w-100">
                <img width="120" src="assets/icons/development-1.svg">
                <div class="mt-3 text-center">
                    <h5 class="text-center">Apenas o Empreendimento</h5>
                </div>
            </div>
            <div (click)="typeSelected = 2" class="align-items-center border card cursor-pointer d-flex flex-column h-100 p-4 rounded-3 w-100">
                <img width="120" src="assets/icons/development-2.svg">
                <div class="mt-3 text-center">
                    <h5 class="text-center">Empreendimento com Frações</h5>
                </div>
            </div>
            <div (click)="typeSelected = 3" class="align-items-center border card cursor-pointer d-flex flex-column h-100 p-4 rounded-3 w-100">
                <img width="120" src="assets/icons/development-3.svg">
                <div class="mt-3 text-center">
                    <h5 class="text-center">Empreendimento com Blocos e Frações</h5>
                </div>
            </div>
        </div>
    </div> -->

  <div class="modal-body pt-0">
    <input type="hidden" id="id-field" />
    <div class="row" *ngIf="openModaltSubject$.value===6">
      <div class="card-header">
        <ul ngbNav #customNav="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
          class="nav nav-pills nav-custom-outline nav-primary rounded card-header-tabs border-bottom-0" role="tablist">
          <!-- class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist"> -->
          <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-details' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(this.detailsForm?.errors.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
                                || (this.detailsForm?.errors.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                                || (this.detailsForm?.errors.length>0 && !property)">
                {{this.detailsForm?.errors.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-details-developments [agents]="dataToFormInitAgentsDetails" [submitted]="submitted"
                [detailsForm]="detailsForm" [quantityAvailable]="canActivateProperties.quantity"
                [dataToFormInitDetails]="dataToFormInitDetails" [property]="property"
                [propertyAgentsData]="propertyAgentsData" [canChangeBusinessStatus]="canChangeBusinessStatus"
                [isUpdate]="isUpdate"></app-details-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="13" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-developments.t-units' | translate}}
            </a>
            <ng-template ngbNavContent>
              <app-units [propertyUpdate]="propertyUpdate" [propertyToPermission]="property" [langs]="dataToFormInitAdvertisement?.langs"
                [unitsData]="unitsData" (unitsDataChange)="unitsData = $event" [propertyTypes]="unitsTypes"
                [checkAutoRef]="dataToFormInitDetails?.checkAutoRef"></app-units>
            </ng-template>
          </li>
          <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-address' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="(this.addressForm?.errors.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
                                || (this.addressForm?.errors.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                                || (this.addressForm?.errors.length>0 && !property)">
                {{this.addressForm?.errors.length}}
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-address-developments [submitted]="submitted" [addressForm]="addressForm"
                [dataToFormInitAddress]="dataToFormInitAddress" [property]="property">
              </app-address-developments>
            </ng-template>
          </li>

          <li [ngbNavItem]="3" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="far fa-envelope"></i>
              {{'t-m-properties.t-areas' | translate }}/{{'t-m-properties.t-nearby' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-areas-nearby-developments [submitted]="submitted" [propertyAreasNearbyData]="propertyAreasNearbyData"
                [dataToFormInit]="dataToFormInitAreasNearby" [detailsForm]="detailsForm"
                [dataToFormInitDetails]="dataToFormInitDetails" [property]="property">
              </app-areas-nearby-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="4" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="far fa-envelope"></i>
              {{'t-m-properties.t-charateristics' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-charateristics [submitted]="submitted" [dataToFormInitChar]="dataToFormInitChar"
                [propertyCharateristicsData]="propertyCharateristicsData" [property]="property"
                [detailsForm]="detailsForm" [dataToFormInitDetails]="dataToFormInitDetails"
                [eventName]="'get-data-tab-charateristics-dev'">
              </app-charateristics>
            </ng-template>
          </li>
          <li [ngbNavItem]="6" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-multimedia' | translate }}
              <span class="badge bg-danger rounded-circle"
                *ngIf="(this.propertyMultimediaData?.errors.length>0 && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property))
                                || (this.propertyMultimediaData?.errors.length>0 && permissionsService.canEditProperty(loginUser, property?.store?.id))
                                || (this.propertyMultimediaData?.errors.length>0 && !property)">{{this.propertyMultimediaData?.errors.length}}</span>
            </a>
            <ng-template ngbNavContent>
              <app-multimedia-developments [propertyMultimediaData]="propertyMultimediaData"
                [property]="property"></app-multimedia-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="5" class="nav-item">

            <a ngbNavLink class="nav-link">
              {{'t-m-properties.t-advertisement' | translate }}
              <span class="badge bg-danger rounded-circle"
                *ngIf="(propertyAdvertisementData?.errors.length === dataToFormInitAdvertisement?.langs?.length && (permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && property)) 
                                || (propertyAdvertisementData?.errors.length === dataToFormInitAdvertisement?.langs?.length && permissionsService.canEditProperty(loginUser, property?.store?.id)) 
                                || (propertyAdvertisementData?.errors.length === dataToFormInitAdvertisement?.langs?.length && !property)">
                1
              </span>
            </a>

            <ng-template ngbNavContent>
              <app-advertisement1-developments [submitted]="submitted"
                [dataToFormInitAdvertisement]="dataToFormInitAdvertisement"
                [propertyAdvertisementData]="propertyAdvertisementData" [isActive]="warningSubject$"
                [property]="property">
              </app-advertisement1-developments>
            </ng-template>
          </li>

          <li [ngbNavItem]="7" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-agents' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-agents-developments [dataToFormInitAgents]="dataToFormInitAgents"
                [propertyAgentsData]="propertyAgentsData" [property]="property" [detailsForm]="detailsForm"
                [dataToFormInitDetails]="dataToFormInitDetails" [isUpdate]="isUpdate"></app-agents-developments>
            </ng-template>
          </li>

          <!-- Com PROPERTY_OWNERS alargado à entidade a tab abre em leitura: os botões de adicionar/editar/remover lá dentro continuam gated por permissão de edição. -->
          <li [ngbNavItem]="8" class="nav-item"
            *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property || permissionsService.hasEntityDataScope('PROPERTY_OWNERS')">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-contacts' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-contacts-developments [propertyCostumersContactsData]="propertyCostumersContactsData"
                [propertyOwnersContactsData]="propertyOwnersContactsData" [propertyId]="propertyId"
                [property]="property"></app-contacts-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="9" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-portals' | translate }}
              <span class="badge bg-danger rounded-circle" *ngIf="portalsLogs && portalsLogs > 0">{{portalsLogs}}</span>
            </a>
            <ng-template ngbNavContent>
              <app-portals-developments [dataToFormInitPortals]="dataToFormInitPortals"
                [propertyPortalsData]="propertyPortalsData" [propertyId]="propertyId"
                [property]="property"></app-portals-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="10" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-documents' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-documents-developments [propertyDocumentsData]="propertyDocumentsData"
                [property]="property"></app-documents-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="11" class="nav-item"
            *ngIf="permissionsService.hasPermission('VIEW_PROPOSALS') && (property || permissionsService.canEditProperty(loginUser, property?.store?.id, true))">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-proposals' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-proposals-developments [openProposal]="openProposal" [typeRent]="dataToFormInitDetails?.typeRent"
                [statusList]="statusList" [agents]="dataToFormInitAgentsDetails" [allAgents]="dataToFormInitAgents"
                [detailsForm]="detailsForm" [propertyProposalsData]="propertyProposalsData"
                [proposalsWindowDraftData]="proposalsWindowDraftData"
                [property]="property"></app-proposals-developments>
            </ng-template>
          </li>
          <li [ngbNavItem]="12" *ngIf="property && propertyReviewData" class="nav-item">
            <a ngbNavLink class="nav-link">
              <i class="fas fa-home"></i>
              {{'t-m-properties.t-reviews' | translate }}
            </a>
            <ng-template ngbNavContent>
              <app-visit-reviews-developments [property]="property" [propertyAgentsData]="propertyAgentsData"
                [propertyReviewData]="propertyReviewData"></app-visit-reviews-developments>
            </ng-template>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <!-- <ngx-simplebar class="px-3 mx-n3 mb-2"
                        style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
                        [options]="{ forceVisible: true }"> -->
          <div [ngbNavOutlet]="customNav"></div>
          <!-- </ngx-simplebar> -->
        </div>
      </div>

      <!--end col-->
    </div>
    <!--end row-->

  </div>

  <div class="modal-footer bg-body d-flex">
    <!-- <div class="flex-grow-1">
            <span class="badge badge-soft-danger badge-border fs-12 mt-1 me-1" placement="top"
                ngbTooltip="check details tab" *ngIf="submitted && !detailsForm?.valid"> <i
                    class="ri-error-warning-line"></i> Error on
                details tab</span>
            <span class="badge badge-soft-danger badge-border fs-12 mt-1 me-1" placement="top"
                ngbTooltip="check Address tab" *ngIf="submitted && !addressForm?.valid"> <i
                    class="ri-error-warning-line"></i> Error on
                address tab</span>
            <span class="badge badge-soft-danger badge-border fs-12 mt-1 me-1" placement="top"
                ngbTooltip="check Advertisement tab" *ngIf="submitted && !propertyAdvertisementData?.valid"> <i
                    class="ri-error-warning-line"></i> Error on advertisement
                tab</span>
        </div> -->
    <div class="hstack gap-3 flex-grow-1 h-25 mt-3" *ngIf="property">
      <div>{{'t-m-properties.t-updated-at' | translate }}: <span
          class="fw-medium">{{createDateFormat(propertyUpdate.updated)}}</span></div>
      <div class="vr"></div>
      <div>
        {{'t-m-properties.t-status' | translate }} :
        <span class="badge rounded-pill fs-12"
          [ngClass]="{'badge-soft-success':propertyUpdate?.status,'badge-soft-danger':!propertyUpdate?.status}">
          {{propertyUpdate.status?'Active':'Inactive'}}
        </span>
      </div>

    </div>
    <div class="hstack gap-2 justify-content-end" id="btn-property-modal-footer">
      <button class="btn btn-light d-none" id="btn-property-warning-dev" type="button" data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRightDev" aria-controls="offcanvasRightDev"></button>
      <button type="button" class="btn btn-soft-dark waves-effect waves-light" data-bs-dismiss="modal"
        (click)="modal.close('Close click')">{{'t-close' | translate}}</button>
      <button type="button" class="btn btn-primary" id="add-btn" (click)="saveProperty()"
        [attr.disabled]="requiredSubject$.getValue()?true:null"
        *ngIf="loginUser.id===propertyUpdate?.mainAgent || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">{{textAddOrUpdateModal
        |
        translate}}</button>
    </div>
  </div>
  <!-- Placement Offcanvas -->

  <!-- right offcanvas -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRightDev" aria-labelledby="offcanvasRightDevLabel">
    <div class="offcanvas-header p-0">
      <div class="alert alert-danger alert-dismissible alert-additional fade show mb-0" role="alert">
        <div class="alert-body">
          <div class="d-flex">
            <div class="flex-shrink-0 me-3">
              <i class="ri-alert-line fs-16 align-middle"></i>
            </div>
            <div class="flex-grow-1">
              <h5 class="alert-heading">{{'t-are-you-sure-you-want-to-save' | translate}}</h5>
              <p class="mb-0">{{'t-some-fields-are-not-filled-in' | translate}}</p>
            </div>
          </div>
        </div>
        <div class="alert-content border-0" style="border-radius: 0;">
          <p class="mb-0">
            {{'t-m-properties.t-the-following-fields-are-mandatory-to-activate-the-property' | translate}}
          </p>
        </div>
      </div>
      <!-- <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
    </div>
    <div class="offcanvas-body">
      <h6 class="fs-15" *ngIf="!canActivateProperties.available">{{'t-validation.t-general' | translate}}</h6>
      <ng-container *ngIf="!canActivateProperties.available">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p [innerHTML]="authService.currentUserValue.role?.name==='MASTER' ? ('t-validation.t-properties-limit' | translate) : ('t-validation.t-properties-limit-agent' | translate)"
              class="text-muted mb-0">
            </p>
          </div>
        </div>
      </ng-container>
      <h6 class="fs-15" *ngIf="detailsForm?.errors?.length>0">{{'t-details' | translate}}</h6>
      <ng-container *ngFor="let error of detailsForm?.errors; index as i">
        <div class="d-flex mt-2 mb-4" *ngIf="error.type?.warning && error.key==='reference'">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill" [ngClass]="{' text-danger':error.type?.warning}"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-m-properties.t-info-key-form.t-'+error.key | translate}} {{'t-exist' |
              translate}}
            </p>
          </div>
        </div>
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{' text-warning':error.type?.warning, ' text-danger':error.type?.required}"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-m-properties.t-info-key-form.t-'+error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
            <p class="text-muted mb-0" *ngIf="error.type?.required">
              {{'t-m-properties.t-info-key-form.t-'+error.key | translate}}
              {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' |
              translate}}
            </p>
          </div>
        </div>
      </ng-container>
      <h6 class="fs-15" *ngIf="addressForm?.errors?.length>0">
        {{'t-m-properties.t-address' | translate}}
      </h6>
      <ng-container *ngFor="let error of addressForm?.errors; index as i">
        <div class="d-flex mt-2 mb-4">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{' text-warning':error.type?.warning, ' text-danger':error.type?.required}"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="error.type?.warning">
              {{'t-'+error.key | translate }}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>
            <p class="text-muted mb-0" *ngIf="error.type?.required">
              {{'t-'+error.key | translate }}
              {{'t-m-properties.t-is-mandatory-to-save-and-activate-the-property' |
              translate}}
            </p>
          </div>
        </div>
      </ng-container>
      <h6 class="fs-15" *ngIf="propertyAdvertisementData?.errors?.length===dataToFormInitAdvertisement?.langs?.length">
        {{'t-m-properties.t-advertisement' | translate }}
      </h6>
      <ng-container *ngIf="propertyAdvertisementData?.errors?.length===dataToFormInitAdvertisement?.langs?.length">
        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill"
              [ngClass]="{' text-warning':propertyAdvertisementData?.errors[0].type?.warning || propertyAdvertisementData?.errors[0].type?.required}"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0" *ngIf="propertyAdvertisementData?.errors[0].type?.warning">
              {{'t-title' | translate }}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>

          </div>
        </div>
      </ng-container>
      <h6 class="fs-15" *ngIf="propertyMultimediaData?.errors?.length===1">
        {{'t-m-properties.t-multimedia' | translate }}
      </h6>
      <ng-container *ngIf="propertyMultimediaData?.errors?.length===1">
        <div class="d-flex mt-2 mb-3">
          <div class="flex-shrink-0">
            <i class="ri-checkbox-circle-fill text-warning"></i>
          </div>
          <div class="flex-grow-1 ms-2">
            <p class="text-muted mb-0">
              {{'t-m-properties.t-images' | translate }}
              {{'t-or' | translate }}
              {{'t-m-properties.t-videos' | translate | lowercase }}
              {{'t-m-properties.t-is-mandatory-to-activate-the-property' | translate}}
            </p>

          </div>
        </div>
      </ng-container>
    </div>
    <div class="offcanvas-footer border-top p-3 text-center">
      <div class="row">
        <div class="col-6">
          <button type="button" class="btn btn-outline-primary w-100" id="btn-warning-no"
            data-bs-dismiss="offcanvas">{{'t-m-properties.t-no' | translate}}</button>
        </div>
        <div class="col-6">
          <a (click)="saveProperty(true)" class="btn btn-outline-danger w-100">
            {{'t-m-properties.t-yes' | translate}},
            {{'t-save' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="propertyLoader" [ngClass]="{'d-none':!isSave}">
    <div class="avatar-sm spinner-border text-primary" role="status">
      <span class="visually-hidden">wait...</span>
    </div>
  </div>

  <div class="propertyLoader2 d-none">
    <div class="avatar-sm spinner-border text-primary" role="status">
      <span class="visually-hidden">wait...</span>
    </div>

    <div class="fs-14 ps-3 text-primary" role="status">
      <span>{{'t-generating-new-reference'|translate}}...</span>
    </div>
  </div>
</ng-template>

<!-- Modal: refletir alterações do empreendimento nas frações -->
<ng-template #propagateFractionsModal let-modal>
  <div class="modal-header bg-light py-3">
    <div>
      <h5 class="modal-title mb-1">
        <i class="ri-share-forward-line align-middle me-2 text-primary"></i>{{ 't-propagate.t-modal-title' | translate }}
      </h5>
      <p class="text-muted fs-13 mb-0">
        {{ 't-propagate.t-modal-subtitle' | translate: { count: propagateFractionsCount } }}
      </p>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">

    <div class="d-flex justify-content-end align-items-center mb-3">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" role="switch" id="prop-select-all"
          [checked]="areAllPropagateSelected()" (click)="toggleAllPropagate()" />
        <label class="form-check-label fw-medium" for="prop-select-all">{{ 't-propagate.t-select-all' | translate }}</label>
      </div>
    </div>

    <div *ngFor="let g of propagateGroupedFields" class="card border shadow-none mb-3">
      <div class="card-header py-2 d-flex justify-content-between align-items-center bg-light">
        <h6 class="mb-0 fw-bold">{{ g.label }}</h6>
        <div class="form-check form-switch mb-0">
          <input class="form-check-input" type="checkbox" role="switch" [id]="'prop-group-' + g.group"
            [checked]="isPropagateGroupAllSelected(g)" (click)="togglePropagateGroup(g)" />
        </div>
      </div>
      <div class="card-body py-2">
        <div *ngFor="let field of g.fields; let last = last"
          class="d-flex align-items-start py-2" [class.border-bottom]="!last">
          <div class="form-check form-switch mt-1 me-2">
            <input class="form-check-input" type="checkbox" role="switch" [id]="'prop-' + field.key"
              [(ngModel)]="propagateSelection[field.key]" [ngModelOptions]="{ standalone: true }" />
          </div>
          <label class="flex-grow-1 mb-0" [for]="'prop-' + field.key" style="cursor: pointer;">
            <span class="fw-medium">{{ getPropagateFieldLabel(field) }}</span>
            <span *ngIf="field.commercial" class="badge bg-warning-subtle text-warning ms-2"
              [ngbTooltip]="'t-propagate.t-commercial-locked-tooltip' | translate">
              <i class="ri-lock-line align-middle"></i> {{ 't-propagate.t-commercial-locked' | translate }}
            </span>
            <div class="fs-13 text-muted mt-1">
              <span class="text-decoration-line-through">{{ formatPropagateValue(field.oldValue) }}</span>
              <i class="ri-arrow-right-line align-middle mx-2"></i>
              <span class="text-success fw-medium">{{ formatPropagateValue(field.newValue) }}</span>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between align-items-center">
    <span class="text-muted fs-13">
      {{ 't-propagate.t-selected-count' | translate: { selected: countPropagateSelected(), total: propagateChangedFields.length } }}
    </span>
    <div>
      <button type="button" class="btn btn-light me-2" [disabled]="propagatingFractions" (click)="modal.dismiss()">
        {{ 't-propagate.t-btn-skip' | translate }}
      </button>
      <button type="button" class="btn btn-primary"
        [disabled]="propagatingFractions || !hasAnyPropagateSelected()"
        (click)="confirmPropagateToFractions(modal)">
        <span *ngIf="propagatingFractions" class="spinner-border spinner-border-sm me-2" role="status"
          aria-hidden="true"></span>
        {{ 't-propagate.t-btn-confirm' | translate }}
      </button>
    </div>
  </div>
</ng-template>
